import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import QuoteForm from '../../../components/base/QuoteForm';
import { Link } from 'react-router-dom';

const GutterCleaningPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Professional <strong>Gutter Cleaning</strong> in <strong>Northwest Arkansas</strong>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Keep your gutters flowing freely with expert <strong>gutter cleaning services</strong> in <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong>. Prevent water damage and protect your home's foundation.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                  <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
                </a>
                <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                  Get Free Quote
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://public.readdy.ai/ai/img_res/cd4b6a25654e6c67106934022e0b3e1b.jpg"
                alt="Professional gutter cleaning service"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Clean Gutters */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Why Regular <strong>Gutter Cleaning</strong> is Essential
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Clogged gutters can cause serious damage to your <strong>Northwest Arkansas</strong> home
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-home-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Foundation Protection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Prevent water from pooling around your foundation, which can cause cracks, settling, and costly structural damage.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-water-flash-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Prevent Water Damage</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Stop water from overflowing and damaging your siding, windows, doors, and interior walls.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-bug-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Pest Prevention</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Remove debris that attracts mosquitoes, rodents, and other pests that can nest in clogged gutters.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-plant-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Landscape Protection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Prevent erosion and protect your landscaping from excessive water runoff and soil washout.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-shield-check-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Roof Protection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Prevent water backup that can damage your roof, fascia boards, and cause ice dams in winter.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Save Money</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Regular cleaning is far less expensive than repairing water damage, foundation issues, or replacing rotted wood.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Our <strong>Gutter Cleaning</strong> Process
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Professional, thorough cleaning that protects your home
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Inspection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We inspect your gutters and downspouts to assess the level of debris and identify any damage.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Debris Removal</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We remove all leaves, twigs, dirt, and debris from your gutters by hand and with professional tools.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Flushing</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We flush your gutters and downspouts with water to ensure proper flow and clear any remaining debris.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Cleanup</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We bag and remove all debris from your property, leaving your home clean and your gutters flowing freely.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6">
              Schedule Your <strong>Gutter Cleaning</strong> Today
            </h2>
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-teal-50">
              Don't wait for damage to occur. Call <strong>NWA Gutter Guards</strong> for professional <strong>gutter cleaning</strong> in <strong>Northwest Arkansas</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                <i className="ri-phone-line mr-2"></i> Call (479) 337-7565
              </a>
              <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                Request Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <QuoteForm 
              title="Schedule Your Service Today"
              subtitle="Professional gutter cleaning, repair, or free gutter guard estimate"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GutterCleaningPage;